import React, { useEffect, useState } from 'react';
import { callApi } from '../../api/callApi';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import Layout from '../../components/Layout/Layout';
import { IRecipe } from '../../interfaces/recipes';
import { Link, useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../components/UI/Modal/ConfirmationModal';
import useConfirmationModal from '../../hooks/useConfirmationModal';
import Table from '../../components/UI/CommonTable/CommonTable';
import Pagination from '../../components/UI/List/Pagination';

const Recipes: React.FC = () => {
    const [recipes, setRecipes] = useState<IRecipe[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const { showModal, modalProps, confirmAction } = useConfirmationModal();

    const navigate = useNavigate()
    useEffect(() => {
        getRecipes(currentPage);
    }, [currentPage]);

    const getRecipes = async (page: number = 1) => {
        try {
            setLoading(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + `recipes?page=${page}&sortType=ASC`, { method: 'GET' });
            const { currentPage, data, totalPages } = response;
            setRecipes(data);
            setCurrentPage(currentPage);
            setTotalPages(totalPages);
        } catch (error: any) {
            console.error('Failed to fetch recipes:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const deleteRecipe = async (id: string) => {
        try {
            await callApi(API_URL_2 + API_ENDPOINT.page + `recipes/${id}`, { method: 'DELETE' });
            setRecipes((prevRecipes: IRecipe[]) => prevRecipes.filter(recipe => recipe.id !== id));
        } catch (error: any) {
            console.error('Failed to fetch sections:', error.message);
        } finally {
            setLoading(false);
        }
    }

    const handleDeleteClick = (id: string) => {
        confirmAction({
            title: 'Confirm Delete',
            message: 'Are you sure you want to delete this recipe?',
            onConfirm: () => deleteRecipe(id),
        });
    };


    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const columns = [
        {
            header: "Image",
            accessor: "images",
            render: (images: string[]) => <div className='table-image'>
                <img className="img-image" src={images && images[0]} alt="" />
            </div>,
        },
        { header: "Title", accessor: "title" },

        {
            header: "Meal Type",
            accessor: "mealType",
        },
    ];

    const actions = [
        {
            icon: "bi bi-pen",
            color: "success",
            onClick: (recipe: IRecipe) => navigate(`/edit-recipe/${recipe.id}`),
        },
        {
            icon: "bi bi-trash3",
            color: "danger",
            onClick: (recipe: IRecipe) => handleDeleteClick(recipe.id),
        },
    ];


    return (
        <Layout>
            <div className='d-flex justify-content-between align-items-start'>
                <h1 className="app-page-title">Recipes</h1>
                <Link to={"/add-recipe"} className='btn app-btn-primary d-flex align-items-center gap-1'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.13261 0 6.25979 0.0526785 6.35355 0.146447C6.44732 0.240215 6.5 0.367392 6.5 0.5V5.5H11.5C11.6326 5.5 11.7598 5.55268 11.8536 5.64645C11.9473 5.74021 12 5.86739 12 6C12 6.13261 11.9473 6.25979 11.8536 6.35355C11.7598 6.44732 11.6326 6.5 11.5 6.5H6.5V11.5C6.5 11.6326 6.44732 11.7598 6.35355 11.8536C6.25979 11.9473 6.13261 12 6 12C5.86739 12 5.74021 11.9473 5.64645 11.8536C5.55268 11.7598 5.5 11.6326 5.5 11.5V6.5H0.5C0.367392 6.5 0.240215 6.44732 0.146447 6.35355C0.0526785 6.25979 0 6.13261 0 6C0 5.86739 0.0526785 5.74021 0.146447 5.64645C0.240215 5.55268 0.367392 5.5 0.5 5.5H5.5V0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526785 5.86739 0 6 0Z" fill="white" />
                </svg> Add Recipes</Link>
            </div>
            <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                <div className="app-card-body">

                    <Table
                        columns={columns}
                        data={recipes}
                        loading={loading}
                        actions={actions}
                        emptyMessage="No products available."
                    />
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
            <ConfirmationModal {...modalProps} show={showModal} />
        </Layout>
    );
};

export default Recipes;
